import { useThemeMode } from "portal/theme/ThemeProvider";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import React, { FC } from "react";
import Switch from "@mui/material/Switch";

export const ThemeModeSwitch: FC = () => {
  const { mode, toggleMode } = useThemeMode();
  return (
    <Switch
      onChange={() => {
        toggleMode();
      }}
      color="default"
      checked={mode === "light"}
      icon={
        <div className="flex rounded-full text-carbon-gray-lightest bg-carbon-gray-medium">
          <DarkModeIcon className="flex my-auto p-[2px]" />
        </div>
      }
      checkedIcon={
        <div className="rounded-full text-carbon-gray-lightest bg-carbon-gray-medium">
          <LightModeIcon className="flex my-auto p-[2px]" />
        </div>
      }
    />
  );
};
